import React, { useContext, useEffect } from "react"
import classnames from "classnames"
import * as layouts from "layouts"
import * as context from "./context"

interface props extends layouts.containers.FlexProps {
	enabled: boolean
}

export default function Inline(props: React.PropsWithChildren<props>): JSX.Element {
	const { display, children, className, enabled, ...rest } = props

	const { increment } = useContext(context.Context)

	useEffect(() => {
		increment(enabled ? 1 : -1)
	}, [enabled, increment])

	return (
		<layouts.containers.flex
			className={classnames("overlay screen", className)}
			{...rest}
			display={enabled ? display : "none"}
		>
			{children}
		</layouts.containers.flex>
	)
}

Inline.defaultProps = {
	className: "",
	styled: false,
}
